const Mutation = Object.freeze({
	SET_ALERT: 'alertHandling/SET_ALERT',
	UPDATE_ALERT: 'alertHandling/UPDATE_ALERT',
	CLEAR_ALERTS: 'alertHandling/CLEAR_ALERTS',
});

export const Actions = Object.freeze({
	SET_ALERT: 'alertHandling/SET_ALERT',
	UPDATE_ALERT: 'alertHandling/UPDATE_ALERT',
	CLEAR_ALERTS: 'alertHandling/CLEAR_ALERTS',
});

export const Getters = Object.freeze({
	ALERTS: 'alertHandling/ALERTS',
});

import Vue from 'vue';

export default {
	state: {
		alerts: [],
	},
	mutations: {
		[Mutation.SET_ALERT](state, alert) {
			state.alerts = [...state.alerts, alert];
		},
		[Mutation.UPDATE_ALERT](state, alert) {
			let stateAlertIndex = state.alerts.findIndex(
				(stateAlert) => stateAlert.timestamp === alert.timestamp
			);

			Vue.set(state.alerts[stateAlertIndex], 'seen', true);
		},
		[Mutation.CLEAR_ALERTS](state) {
			state.alerts = [];
		},
	},
	actions: {
		[Actions.SET_ALERT]({ commit }, alert) {
			commit(Mutation.SET_ALERT, alert);
		},
		[Actions.UPDATE_ALERT]({ commit }, alert) {
			commit(Mutation.UPDATE_ALERT, alert);
		},
		[Actions.CLEAR_ALERTS]({ commit }) {
			commit(Mutation.CLEAR_ALERTS);
		},
	},
	getters: {
		[Getters.ALERTS]: (state) => {
			return state.alerts;
		},
	},
};
